import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import { serviceInstance } from "utils/axiosInstances";
import { fileDisplayValue } from "./types";

const getDisplayUrlByKey = createAsyncThunk<fileDisplayValue, string, {}>(
  "fileDisplay/getByKey",
  async (key: string) => {
    const response = await serviceInstance.get("/displayUrl", {
      params: { key },
    });
    return response.data.displayUrl as fileDisplayValue;
  }
);

const initialState: fileDisplayValue = {
  url: "",
};

const fileDisplaySlice = createSlice({
  name: "fileDisplay",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getDisplayUrlByKey.fulfilled, (state, action) => {
      return action.payload;
    });
    builder.addCase(getDisplayUrlByKey.rejected, (state, action) => {
      return { error: action.error };
    });
  },
});

export { getDisplayUrlByKey };
export default fileDisplaySlice.reducer;
